/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".business-fuel__disclaimers[_ngcontent-%COMP%]{font-size:13px;color:#666}.business-fuel__source-label[_ngcontent-%COMP%]{margin-right:6px}.delete-icon[_ngcontent-%COMP%], .edit-icon[_ngcontent-%COMP%]{padding:0;margin:0}#add_btn[_ngcontent-%COMP%]{background-color:#00b6ac}  .mat-checkbox-checked .mat-checkbox-background{background-color:#75ba1d!important}  .mat-checkbox-ripple .mat-ripple-element{background-color:rgba(117,186,29,.26)!important}"];
export { styles as styles };
